var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDirectionArrow16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_direction_arrow_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector - North",
    d: "M8.76314 10.4103L5.96902 14.2507C5.90111 14.3441 5.81392 14.4224 5.71396 14.4801C5.32083 14.7071 4.816 14.5736 4.58902 14.1805C4.53035 14.0789 4.49412 13.9659 4.48276 13.8491L3.37854 2.49765C3.34906 2.19458 3.49943 1.90225 3.76314 1.75C4.02684 1.59775 4.3552 1.61368 4.60293 1.79075L13.8814 8.42275C13.9769 8.49098 14.0566 8.57885 14.1153 8.68047C14.3423 9.0736 14.2055 9.57753 13.8123 9.80451C13.7124 9.86222 13.6009 9.89858 13.4862 9.91072L8.76314 10.4103Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDirectionArrow16);
export default __webpack_public_path__ + "static/media/ic_direction_arrow_16.25f3d44188979c7473c4fd97de144179.svg";
export { ForwardRef as ReactComponent };